import React from 'react';
import mark from './assets/logo512.png';

export function Logo() {
  return <img alt="logo" width="35" src={mark}></img>;
}
